export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/piano-icon.svg?e906b53e9b6537dc04156bf3f7a977c7";